import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import SoftInput from "components/SoftInput";
import { IconButton, Checkbox, FormControlLabel } from "@mui/material";
import StatusFilterSelect from "components/StatusFilterSelect";
import SearchIcon from "@mui/icons-material/Search";
import Table from "examples/Tables/Table";
import UsersRow, { columns } from "store/action/User";
import useStore from "store/hook";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import emptyUsers from "assets/images/users/emptyUsers.png";
import SoftPagination from "components/SoftPagination";
import { useGetuserslistQuery } from "store/api/users.api";
import UniversityList from "./components/Universitylist";
import SoftAvatar from "components/SoftAvatar";
import CloseIcon from "@mui/icons-material/Close";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import defaultUniversity from "assets/images/university/defaultuniversity.png";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import useListPageQuery from "services/useListPageQuery";
import useUsersSchoolCityFilters from "services/useUsersSchoolCityFilters";
import { LIST_FILTER_KEYS, showDeletedCheckboxSx, showDeletedLabelSx } from "constants/listFilters";
import ActivateDeactivateUser from "./components/ActivateDeactivateuser";

function UsersList() {
  const [usersData, setUsersData] = useState([]);
  const { page, setPage, resetPage, status, setStatus, showDeleted, setShowDeleted } =
    useListPageQuery(LIST_FILTER_KEYS.USERS);
  const {
    selectedUniversitiesData,
    selectedUniversitiesIdsData,
    selectedUniversities,
    setSelectedUniversities,
    selectedUniversitiesIds,
    setSelectedUniversitiesIds,
    selectedCitiesData,
    selectedCitiesIdsData,
    selectedCities,
    setSelectedCities,
    selectedCitiesIds,
    setSelectedCitiesIds,
    applySchoolCityFilters,
    removeSchool,
    removeCity,
  } = useUsersSchoolCityFilters();
  const [tolatPages, setTotalpages] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [regex, setRegex] = React.useState("");
  const [newRegex, setNewRegex] = React.useState("");
  const committedRegex = useRef("");

  const logout = useLogout();
  const location = useLocation();
  const returnPath = `${location.pathname}${location.search}`;
  const resetPageRef = useRef(resetPage);
  resetPageRef.current = resetPage;

  React.useEffect(() => {
    if (regex === committedRegex.current) return;

    const timeoutId = setTimeout(() => {
      committedRegex.current = regex;
      resetPageRef.current();
      setNewRegex(regex);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [regex]);

  const uniFilter = React.useMemo(
    () => [...selectedUniversitiesIdsData, ...selectedCitiesIdsData],
    [selectedUniversitiesIdsData, selectedCitiesIdsData]
  );

  const { data, isLoading, isFetching, error, refetch } = useGetuserslistQuery({
    page: page,
    limit: 20,
    type: newRegex ? "search" : "list",
    searchText: newRegex,
    uni_filter: uniFilter,
    status: status === "all" ? undefined : status,
    show_deleted: showDeleted,
  });

  const { store, setDialogue } = useStore();

  React.useEffect(() => {
    if (data?.status === 1) {
      setUsersData(data?.data?.users);
      setTotalpages(data?.data?.totalPages);
      setTotalUsers(data?.data?.count ?? data?.data?.totalUsers ?? 0);
    } else if (data?.status == 0) {
      toast.error(Formatmessage(data?.message));
    } else if (data?.status == 10) {
      logout();
    }
  }, [data]);

  const rows = React.useMemo(
    () => (usersData ? usersData?.map((user) => UsersRow(user, setDialogue, returnPath)) : []),
    [usersData, returnPath]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox
        sx={{
          pr: { xs: 1, sm: 2, md: 4 },
          pl: { xs: 1, sm: 2, md: 2 },
          top: { xs: "55%", sm: "40%" },
        }}
        position="absolute"
        width="100%"
      >
        <SoftBox
          border="1px solid #D8E0E8"
          width="100%"
          borderRadius="md"
          sx={{ backgroundColor: "white.main" }}
        >
          <SoftBox
            sx={{ p: 2 }}
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
          >
            <SoftBox display="flex" sx={{ alignItems: "center", justifyContent: "start", gap: 2 }}>
              <SoftTypography sx={{ fontSize: 16, fontWeight: "medium", color: "black.main" }}>
                Users
              </SoftTypography>

              <SoftBox borderRadius="xl" sx={{ backgroundColor: "skyblue.main", px: 2, py: 0.1 }}>
                <SoftTypography sx={{ fontSize: 16, fontWeight: "medium", color: "primary.main" }}>
                  {totalUsers}
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox
              display="flex"
              flexWrap="wrap"
              sx={{ alignItems: "center", justifyContent: "start", gap: 2 }}
            >
              <SoftBox
                sx={{ position: "relative", height: "45px", width: { xs: "100%", sm: "230px" } }}
              >
                {/* Icon Button */}
                <SoftBox
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "5px",
                    transform: "translateY(-50%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <IconButton
                    sx={{
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <SearchIcon sx={{ color: "black.main", width: 20, height: 20 }} />
                  </IconButton>
                </SoftBox>

                <SoftInput
                  name="search"
                  type="text"
                  value={regex}
                  onChange={(e) => setRegex(e.target.value)}
                  placeholder="Search by name"
                  fontSize="14px"
                  sx={{
                    width: "100% !important",
                    py: "10px",
                    pl: "40px",
                  }}
                />
              </SoftBox>

              <StatusFilterSelect
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={showDeleted}
                    onChange={(e) => setShowDeleted(e.target.checked)}
                    sx={showDeletedCheckboxSx}
                  />
                }
                label="Show deleted"
                sx={showDeletedLabelSx}
              />

              <SoftButton
                color="primary"
                variant="outlined"
                sx={{
                  fontSize: 14,
                  textTransform: "capitalize",
                  gap: 2,
                  width: { xs: "100%", sm: "250px" },
                  maxHeight: "45px !important",
                }}
                onClick={() =>
                  setDialogue({
                    type: "openUniversitylist",
                    isOpen: true,
                    action: "",
                  })
                }
              >
                Select Schools & Cities <KeyboardArrowDownIcon sx={{ height: 20, width: 20 }} />
              </SoftButton>
            </SoftBox>
          </SoftBox>

          <SoftBox
            sx={{ p: 2 }}
            width="100%"
            display="flex"
            gap={1}
            alignItems="center"
            justifyContent="start"
            flexWrap="wrap"
          >
            {selectedUniversitiesData?.length > 0 &&
              selectedUniversitiesData.map((school) => (
                <SoftBox
                  display="flex"
                  border="2px solid #3DC2EB"
                  borderRadius="md"
                  sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    px: 1,
                    py: 1,
                  }}
                  key={school?._id}
                >
                  <SoftBox display="flex" alignItems="center" justifyContent="center" gap={2}>
                    <SoftBox borderRadius="50%">
                      <SoftAvatar
                        src={school?.school_image || defaultUniversity}
                        alt="school"
                        size="xs"
                      />
                    </SoftBox>
                    <SoftTypography fontWeight="normal" sx={{ fontSize: 14, color: "black.main" }}>
                      {school?.school_name}
                    </SoftTypography>

                    <SoftBox
                      onClick={() => removeSchool(school?._id)}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ cursor: "pointer" }}
                      p={0.5}
                    >
                      <CloseIcon sx={{ color: "black.main" }} />
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              ))}

            {selectedCitiesData?.length > 0 &&
              selectedCitiesData.map((city) => (
                <SoftBox
                  display="flex"
                  border="2px solid #3DC2EB"
                  borderRadius="md"
                  sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    px: 1,
                    py: 1,
                  }}
                  key={city?._id}
                >
                  <SoftBox display="flex" alignItems="center" justifyContent="center" gap={2}>
                    <SoftBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        backgroundColor: "#E2E2E2",
                      }}
                    >
                      <LocationCityOutlinedIcon sx={{ height: 16, width: 16, color: "#555F73" }} />
                    </SoftBox>
                    <SoftTypography
                      fontWeight="normal"
                      sx={{ fontSize: 14, color: "black.main", textTransform: "capitalize" }}
                    >
                      {city?.city}
                    </SoftTypography>

                    <SoftBox
                      onClick={() => removeCity(city?._id)}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ cursor: "pointer" }}
                      p={0.5}
                    >
                      <CloseIcon sx={{ color: "black.main" }} />
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              ))}
          </SoftBox>

          {isLoading || isFetching ? (
            <SoftBox
              sx={{
                height: "calc(60vh)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FadeLoader color="#3DC2EB" />
            </SoftBox>
          ) : (
            <SoftBox>
              {usersData?.length > 0 ? (
                <SoftBox
                  sx={{
                    "& .MuiTableRow-root:not(:last-child)": {
                      "& td": {
                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                          `${borderWidth[1]} solid ${borderColor}`,
                      },
                    },
                  }}
                >
                  <Table columns={columns} rows={rows} />
                </SoftBox>
              ) : (
                <SoftBox
                  sx={{
                    height: "calc(70vh)",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <SoftBox
                    display="flex"
                    flexDirection="column"
                    gap={8}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                  >
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      width="100%"
                      sx={{
                        backgroundColor: "skyblue.main",
                      }}
                    >
                      {columns.map(({ name, align, width }, index) => (
                        <SoftBox
                          key={index}
                          width={width}
                          align={align}
                          fontWeight="medium"
                          fontSize="14px"
                          py="10px"
                          px="24px"
                          color="black"
                          sx={{fontWeight: 500, textTransform: "capitalize" }}
                        >
                          {name}
                        </SoftBox>
                      ))}
                    </SoftBox>

                    <SoftBox display="flex" flexDirection="column" alignItems="center">
                      <SoftBox
                        height="200px"
                        width="200px"
                        borderRadius="lg"
                        sx={{
                          backgroundImage: `url(${emptyUsers})`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "contain",
                        }}
                      />

                      <SoftTypography fontWeight="bold" color="black" sx={{ fontSize: 20 }}>
                        No Users Available
                      </SoftTypography>
                      <SoftTypography fontWeight="medium" color="gray" sx={{ fontSize: 12 }}>
                        We couldn’t find any users for your search. Please refine your keywords or
                        once users sign up, they will appear here.
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              )}
            </SoftBox>
          )}
        </SoftBox>

        <SoftPagination Totalpages={tolatPages || 0} currentPage={page} changePage={setPage} />
      </SoftBox>

      {/* External popos and components */}
      <UniversityList
        selectedUniversitiesData={selectedUniversitiesData}
        selectedUniversitiesIdsData={selectedUniversitiesIdsData}
        selectedUniversities={selectedUniversities}
        setSelectedUniversities={setSelectedUniversities}
        selectedUniversitiesIds={selectedUniversitiesIds}
        setSelectedUniversitiesIds={setSelectedUniversitiesIds}
        selectedCitiesData={selectedCitiesData}
        selectedCitiesIdsData={selectedCitiesIdsData}
        selectedCities={selectedCities}
        setSelectedCities={setSelectedCities}
        selectedCitiesIds={selectedCitiesIds}
        setSelectedCitiesIds={setSelectedCitiesIds}
        onApply={applySchoolCityFilters}
      />

      <ActivateDeactivateUser/>
    </DashboardLayout>
  );
}

export default UsersList;
